import React from 'react';
import {reduxForm} from 'redux-form';
import {createLabelHelper} from 'infrastructure/js/utils/labelHelper';
import Grid from 'infrastructure/js/components/Grid/gridWrapper';
import {gridsNames} from '../../../../../enums/gridsNames';
import {filterTypes} from 'infrastructure/js/enums/filterTypes';
import LabelWithTooltipCell from '../../../../Common/CustomGridCells/LabelWithTooltipCell/labelWithTooltipCell';
import DateTimeHelper from 'infrastructure/js/utils/dateTimeHelper';
import GridHelper from 'infrastructure/js/components/Grid/Utils/gridHelper';
import {enumTypes, getEnumLabel} from '../../../../../utils/enumHelper';

require('./qplTestsViewGrid.scss');

class QplTestsViewGrid extends React.PureComponent {

  filterConfig = [
    {fieldName: 'name', filterName: 'testName', getOptions: true},
    {fieldName: 'description', filterName: 'description', getOptions: true},
    {fieldName: 'type', filterName: 'testType', getOptions: true},
    {fieldName: 'lastUpdated', filterName: 'lastUpdated', getOptions: true},
  ];

  constructor(props) {
    super(props);

    this.labels = createLabelHelper('mat.administration.matsettings.qplTests.grid.');

    this.columnsConfig = this.createColumnsConfig();
  }

  createColumnsConfig = () => {
    return [
      {
        fieldName: 'name',
        title: this.labels.get('columns.testName.title'),
        filterType: filterTypes.MULTI_SELECT,
        filterName: 'testName',
        columnOptions: {
          cellComponent: LabelWithTooltipCell,
        }
      },
      {
        fieldName: 'description',
        title: this.labels.get('columns.testCode.title'),
        filterType: filterTypes.MULTI_SELECT,
        filterName: 'description',
        columnOptions: {
          cellComponent: LabelWithTooltipCell,
        }
      },
      {
        fieldName: 'type',
        title: this.labels.get('columns.testType.title'),
        filterType: filterTypes.MULTI_SELECT,
        filterName: 'testType',
        columnOptions: {
          cellComponent: LabelWithTooltipCell,
          valueGetter: (params) => {
            return getEnumLabel(enumTypes.TEST_TYPE)(params.data?.type);
          }
        }
      },
      {
        fieldName: 'lastUpdated',
        title: this.labels.get('columns.lastUpdate.title'),
        filterType: filterTypes.HORIZON,
        filterName: 'lastUpdated',
        width: 150,
        columnOptions: {
          cellComponent: LabelWithTooltipCell,
          valueGetter: (params) => {
            return params.data ? DateTimeHelper.DateFormat(params.data?.lastUpdated?.epochDateTime * 1000) : '';
          },
          headerComponentParams: GridHelper.getDateFormatHeaderIcon(),
        }
      },
    ]
  };

  render() {
    return (
      <div className="administration-view-grid qpl-tests-view-grid">
        <Grid gridName={gridsNames.ADMINISTRATION_MAT_SETTINGS_QPL_TESTS}
              columnsConfig={this.columnsConfig}
              actions={this.props.actions}
              filterConfig={this.filterConfig}
        >
        </Grid>
      </div>
    );
  }
}

export default reduxForm({
    form: 'qplTestsViewGrid'
  }
)(QplTestsViewGrid);
